<template>
    <el-dialog
        :visible="visible"
        :width="width"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="!isSubmiting"
        :show-close="!isSubmiting"
        :destroy-on-close="true"
        custom-class="micro-delete-modal"
        @update:visible="$emit('update:visible', $event)"
        @closed="$emit('closed')"
    >
        <div class="px-4 d-flex flex-column justify-content-center align-items-center" v-loading="isLoading">
            <!-- Ícone -->
            <slot name="icon">
                <el-tag class="d-flex align-items-center justify-content-center rounded-circle" type="danger" :style="{ width: '64px', height: '64px' }">
                    <i :class="icon" :style="{ fontSize: '32px' }"></i>
                </el-tag>
            </slot>

            <!-- Título / Descrição -->
            <div class="text-center my-2">
                <slot name="header">
                    <h4 class="font-weight-bold">{{ title }}</h4>
                    <h5 v-if="description" class="text-muted">{{ description }}</h5>
                </slot>
            </div>

            <!-- Actions -->
            <div class="d-flex align-items-center justify-content-center mt-3">
                <el-button
                    type="danger"
                    plain
                    :disabled="isLoading || isSubmiting"
                    @click="$emit('cancel')"
                >
                    {{ cancelText }}
                </el-button>

                <el-button
                    type="danger"
                    :disabled="disabled || isLoading || isSubmiting"
                    @click="$emit('confirm')"
                >
                    {{ confirmText }}
                    <i v-if="isSubmiting" class="el-icon-loading"></i>
                    <i v-else :class="icon"></i>
                </el-button>
            </div>
        </div>

        <!-- Conteúdo extra (ex: identificação do registro) -->
        <template v-if="$slots.default">
            <el-divider class="mt-3"></el-divider>
            <slot></slot>
        </template>
    </el-dialog>
</template>
<script>
    /**
     * Esqueleto padrão para modais de exclusão.
     *
     * Uso:
     * <DeleteModal
     *     :visible.sync="showModal"
     *     :is-loading="isLoading"
     *     :is-submiting="isSubmiting"
     *     :disabled="!id"
     *     description="Deseja realmente excluir este registro?"
     *     @cancel="close"
     *     @confirm="onSubmit"
     *     @closed="resetModal"
     * >
     *     (opcional) conteúdo exibido abaixo do divider
     * </DeleteModal>
     */
    import {
        Loading,
        Button,
        Dialog,
        Divider,
        Tag,
    } from "element-ui";

    export default {
        name: 'DeleteModal',
        props: {
            visible: { type: Boolean, default: false },
            isLoading: { type: Boolean, default: false },
            isSubmiting: { type: Boolean, default: false },
            disabled: { type: Boolean, default: false },
            title: { type: String, default: 'Tem certeza dessa ação?' },
            description: { type: String, default: 'Deseja realmente excluir este registro? Esta ação não poderá ser desfeita.' },
            confirmText: { type: String, default: 'Deletar' },
            cancelText: { type: String, default: 'Cancelar' },
            icon: { type: String, default: 'el-icon-delete' },
            width: { type: String, default: '650px' },
        },
        directives: {
            loading: Loading.directive,
        },
        components: {
            [Button.name]: Button,
            [Dialog.name]: Dialog,
            [Divider.name]: Divider,
            [Tag.name]: Tag,
        },
    }
</script>
<style>
    /* Não-scoped: o el-dialog é renderizado no body (append-to-body) */
    .micro-delete-modal {
        border-radius: 20px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/_micro/modals/DeleteModal.vue